var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinusMoney = function SvgMinusMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "minus-money_svg__a",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.691.436h35v35h-35z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#minus-money_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    x: 0.691,
    y: 0.436,
    fill: "#FF2E5B",
    rx: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.083 19.663h4.672v-2.736h-4.672v-1.56c0-1.825 1.132-2.953 2.842-2.953 1.445 0 2.456.768 2.745 2.113h3.203c-.361-3-2.65-4.897-5.948-4.897-3.588 0-5.996 2.256-5.996 5.737v1.56h-1.421v2.736h1.42v3.84h-1.42v2.737H24.56v-2.736h-8.477z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B3552",
    d: "M23.023 4.92h12.668v3.31H23.023z"
  })));
};
export { SvgMinusMoney as ReactComponent };
export default __webpack_public_path__ + "images/minus-money.svg";